import React, { type FC } from 'react'

import styled from '@emotion/styled'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import { Flex, TEXT_VARIANT_LIGHT, Text, Toggle } from 'mailup-web-components'

import { modalSubscribeToggleFieldCallback } from 'Pages/RecipientsList/recoil/callbacks/modalSubscribe'
import {
  modalSubscribeIsSMSOnlyState,
  modalSubscribeState,
} from 'Pages/RecipientsList/recoil/state/modalSubscribe'

const StyledToggleLabel = styled.label`
  cursor: pointer;
`

const InputForceSubscription: FC = () => {
  const intl = useIntl()

  const { forceSubscription } = useRecoilValue(modalSubscribeState)

  const isSMSOnly = useRecoilValue(modalSubscribeIsSMSOnlyState)

  const toggle = useRecoilCallback(modalSubscribeToggleFieldCallback, [])

  const handleToggle = (): void => {
    void toggle('forceSubscription')
  }

  return (
    <section>
      <Flex flexDirection="row" alignItems="center" gap="8px">
        <Toggle
          data-mu-test="toggle-force-subscription"
          variant="sm"
          checked={forceSubscription}
          onChange={handleToggle}
          id="toggle-force-subscription"
        />

        <StyledToggleLabel htmlFor="toggle-force-subscription">
          {intl.formatMessage({
            id: 'Load.RecipientsList.ModalSubscribeForceSubscriptionLabel',
          })}
        </StyledToggleLabel>
      </Flex>

      <Flex flexDirection="column" margin="8px 0 0 45px">
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: isSMSOnly
              ? 'Load.RecipientsList.ModalSubscribeForceSubscriptionSMSDescription'
              : 'Load.RecipientsList.ModalSubscribeForceSubscriptionDescription',
          })}
        </Text>
      </Flex>
    </section>
  )
}

export default InputForceSubscription
